export const PAGE_FORM_NAME = 'about';



// WEBPACK FOOTER //
// ./src/modules/PageForm/constants.js